import { useMemo } from "react";
import { deriveTrendSummary } from "../../services/retroDerivations";
import { fmtScore } from "../../services/retroFormatters";

export default function TrendCard({ trend }) {
  const s = useMemo(() => deriveTrendSummary(trend), [trend]);
  const max = s.max || 10;

  return (
    <div className="rtv2-card">
      <div className="rtv2-card-head">
        <div>
          <h3>Weekly trend <em>— last 8 weeks</em></h3>
          <span className="sub">Composite score · /10</span>
        </div>
        <div className="rtv2-trend-summary">
          <span className="now">{fmtScore(s.now)}<small>/10</small></span>
          <span className={`delta ${s.delta >= 0 ? "up" : "down"}`}>{s.delta >= 0 ? "▲" : "▼"} {s.delta >= 0 ? "+" : ""}{fmtScore(s.delta)} vs prior</span>
        </div>
      </div>
      <div className="rtv2-trend-bars">
        {trend.map((w) => (
          <div className="bar-wrap" key={w.id}>
            <div className="bar-label">{fmtScore(w.score)}</div>
            <div className="bar-track">
              <i style={{ height: `${Math.max(4, (w.score / max) * 100)}%` }} />
            </div>
            <div className="bar-x">{w.label}</div>
            <div className="bar-sub">{w.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
